const ORDER_PAUSE_KEY = 'order_pause_status';

export interface OrderPauseStatus {
  paused: boolean;
  reason: string;
  customReason?: string;
  pausedAt: number | null;
}

export const PAUSE_REASONS = [
  { id: 'busy', label: 'Delivery boy is busy', icon: 'ri-e-bike-2-line' },
  { id: 'overflow', label: 'Too many orders — cannot accept new orders right now', icon: 'ri-stack-overflow-line' },
  { id: 'stock', label: 'Order stock out due to high demand', icon: 'ri-stock-line' },
  { id: 'custom', label: 'Custom Reason', icon: 'ri-edit-2-line' },
];

export function getOrderPauseStatus(): OrderPauseStatus {
  try {
    const saved = localStorage.getItem(ORDER_PAUSE_KEY);
    if (saved) return JSON.parse(saved) as OrderPauseStatus;
  } catch { /* ignore */ }
  return { paused: false, reason: '', pausedAt: null };
}

export function saveOrderPauseStatus(status: OrderPauseStatus): void {
  try {
    localStorage.setItem(ORDER_PAUSE_KEY, JSON.stringify(status));
  } catch { /* ignore */ }
}
